import { Injectable } from '@angular/core';
import { Api } from '..';

export class condPag {
  public idCondPag: number;
  public condPag: string;

  constructor() {
    this.idCondPag = 0;
    this.condPag = '';
  }
}

@Injectable()
export class CondpagProvider {

  constructor(public api: Api) { }

  gets(idCliente) {
    return this.api.get('condpag/gets', idCliente);
  }

}



// WEBPACK FOOTER //
// ./src/providers/condpag/condpag.ts